module.exports = require("./ff-Adlm-GH");